module.exports = __webpack_public_path__ + "static/media/tcp_robot.045f1e03.png";